import { ModalActionOptions } from '~/stores/useModalsStore';

export function commonFormModalActions(
  labelSave: string,
  onSave: (payload: never) => Promise<{ resolved: boolean, error?: string | string[] }>,
  onCancel?: () => void
): ModalActionOptions[] {
  return [
    {
      label: 'Cancel',
      dismiss: 'always',
      type: 'secondary',
      onClick: onCancel
    },
    {
      label: labelSave || 'Save changes',
      dismiss: 'no-fail',
      type: 'primary',
      onClick: onSave
    }
  ];
}

export function commonFormUnresolvableModalActions(
  labelSave: string,
  onSave: (payload: never) => void,
  alwaysCloseOnSave?: boolean,
  onCancel?: () => void
): ModalActionOptions[] {
  return [
    {
      label: 'Cancel',
      dismiss: 'always',
      type: 'secondary',
      onClick: onCancel
    },
    {
      label: labelSave || 'Save changes',
      dismiss: alwaysCloseOnSave ? 'always' : 'never',
      type: 'primary',
      onClick: onSave
    }
  ];
}

export function dangerConfirmationActions(
  labelDanger: string,
  onDanger: (payload: never) => Promise<{ resolved: boolean, error?: string | string[] }>,
  onCancel?: () => void
): ModalActionOptions[] {
  return [
    {
      label: 'Cancel',
      dismiss: 'always',
      type: 'secondary',
      onClick: onCancel
    },
    {
      label: labelDanger || 'Confirm',
      dismiss: 'no-fail',
      type: 'danger',
      onClick: onDanger
    }
  ];
}

export function regularConfirmationActions(
  labelConfirm: string,
  onConfirm: (payload: never) => Promise<{ resolved: boolean, error?: string | string[] }>,
  onCancel?: () => void
): ModalActionOptions[] {
  return [
    {
      label: 'Cancel',
      dismiss: 'always',
      type: 'secondary',
      onClick: onCancel
    },
    {
      label: labelConfirm || 'Confirm',
      dismiss: 'no-fail',
      type: 'primary',
      onClick: onConfirm
    }
  ];
}
